export { userClass };
import store from "../store";
import firebase from "firebase/app";
import "firebase/messaging";
import { EventBus } from "@/main";
import SimpleCrypto from "simple-crypto-js";
class userClass {
  constructor() {
    EventBus.$on("logOut", this.doLogout);
    //
    EventBus.$on("registerUser", (data, page) => {
      this.registerUser(data, page);
    });
    //
    EventBus.$on("loginUser", data => {
      this.loginUser(data);
    });
    EventBus.$on("initFCM", this.initFCMNotifications);
  }
  doLogout() {
    localStorage.removeItem("AppUser");
    localStorage.removeItem("messageToken");
    localStorage.removeItem("LoginType");
    localStorage.removeItem("fcm_notifications");
    localStorage.removeItem("ListContent");
    store
      .dispatch("actLogout")
      .then(response => {
        // console.log("doLogout", response);
        if (response.error) {
          let ErrorData = {
            Code: response.error,
            Message: response.reason ? response.reason : response
          };
          EventBus.$emit("logoutError", ErrorData);
        } else {
          EventBus.$emit("logoutSuccess");
        }
        // Remove the user data stored in local storage in the name: AppUser
        localStorage.removeItem("AppUser");
        localStorage.removeItem("messageToken");
        localStorage.removeItem("LoginType");
        localStorage.removeItem("fcm_notifications");
        localStorage.removeItem("ListContent");
        store.dispatch("unsubscribeFromTopics", false);
        // Commit User Store
        store.commit("CommitUserStore");
        // reload
        window.location.reload();
        // EventBus.$emit('HomePage')
      })
      .catch(error => {
        // Reload the window
        let ErrorData = {
          Code: error.status,
          Message: error.bodyText ? error.bodyText : error
        };
        EventBus.$emit("logoutError", ErrorData);

        console.log("Logout Error", error);
        // Remove the user data stored in local storage in the name: AppUser
        localStorage.removeItem("AppUser");
        localStorage.removeItem("LoginType");
        localStorage.removeItem("messageToken");
        localStorage.removeItem("fcm_notifications");
        localStorage.removeItem("ListContent");

        // Commit User Store
        store.commit("CommitUserStore");
        // reload
        window.location.reload();
        // EventBus.$emit('HomePage')
      });
  }
  registerUser(data, page) {
    if (!data) {
      let ErrorData = {
        Code: "401",
        Message: "User Details Missing"
      };

      return false;
    }
    (this.subscribername = data.subscribername),
      (this.email = data.email),
      (this.password = data.password);
    data.country = store.getters.country;
    //
    let simpleCrypto = new SimpleCrypto(store.getters.SECRET_KEY);
    //
    let Logindata = {
      type: "EMAIL",
      email: data.email,
      password: simpleCrypto.encrypt(data.password)
    };
    localStorage.setItem("LoginType", JSON.stringify(Logindata));
    // Calling the subscribe API
    store
      .dispatch("actSubscribe", data)
      .then(response => {
        if (response.error) {
          // if (response.error == 2012) {
          //   let params ={
          //     email : this.email
          //   }
          //   if (data.password) {
          //     params.password = this.password
          //   }
          //   this.getRegisteredUserData(params,page);
          // }
          // show error
          if (page == "S") {
            let ErrorData = {
              Code: response.error,
              Message: response.reason ? response.reason : response
            };
            EventBus.$emit("signupError", ErrorData);
          }
          if (response.error !== 2012) {
            if (page == "L") {
              let ErrorData = {
                Code: response.error,
                Message: response.reason ? response.reason : response
              };
              EventBus.$emit("loginError", ErrorData);
            }
          }
          // Them return out of the method
          return;
        }

        let params = {
          email: this.email
        };
        if (data.password) {
          params.password = this.password;
        }
        this.getRegisteredUserData(params, page);
      })
      .catch(error => {
        // show error
        let ErrorData = {
          Code: error.status,
          Message: error.bodyText ? error.bodyText : error
        };
        EventBus.$emit("signupError", ErrorData);
      });
  }
  getRegisteredUserData(data, page) {
    // If no error happened
    store
      .dispatch("actLogin", data)
      .then(response => {
        // If error comes as part of the response,
        if (response.error) {
          // show error
          if (page == "S") {
            let ErrorData = {
              Code: response.error,
              Message: response.reason ? response.reason : response
            };
            EventBus.$emit("signupError", ErrorData);
          }
          if (page == "L") {
            let ErrorData = {
              Code: response.error,
              Message: response.reason ? response.reason : response
            };
            EventBus.$emit("loginError", ErrorData);
          }
          // Them return out of the method
          return;
        } else {
          // Save user data in the name of AppUser to local storage
          localStorage.setItem("AppUser", JSON.stringify(response));
          // Commit User Store
          store.commit("CommitUserStore");
          //
          if (page == "S") EventBus.$emit("signupSuccess");
          if (page == "L") EventBus.$emit("loginSuccess");
          //
          this.initFCMNotifications();
          //
          // window.location.reload()
        }
      })
      .catch(error => {
        let ErrorData = {
          Code: error.status,
          Message: error.bodyText ? error.bodyText : error
        };
        EventBus.$emit("loginError", ErrorData);
      });
  }
  loginUser(data) {
    if (!data) {
      let ErrorData = {
        Code: error.status,
        Message: "User Details Missing"
      };
      EventBus.$emit("loginError", ErrorData);
      return false;
    }
    let params = {};
    let Logindata = {};
    switch (data.app) {
      case "SELF":
        this.email = data.email;
        this.password = data.password;
        params.email = data.email;
        params.password = data.password;
        //
        // Encrypt
        let simpleCrypto = new SimpleCrypto(store.getters.SECRET_KEY);
        Logindata = {
          type: "EMAIL",
          email: data.email,
          password: simpleCrypto.encrypt(data.password)
        };
        localStorage.setItem("LoginType", JSON.stringify(Logindata));
        break;
      case "FB":
        params.fbtoken = data.token;
        //
        Logindata = {
          type: "FB",
          token: data.token
        };
        if (data.email) {
          params.email = Logindata.email = data.email;
        }
        localStorage.setItem("LoginType", JSON.stringify(Logindata));
        break;
      case "GOOGLE":
        params.gtoken = data.token;

        Logindata = {
          type: "GOOGLE",
          token: data.token
        };
        localStorage.setItem("LoginType", JSON.stringify(Logindata));
        break;
    }
    store
      .dispatch("actLogin", params)
      .then(response => {
        // If error comes as part of the response,
        console.log('login response', response);
        if (response.error) {
          if (response.error == 9101) {
            EventBus.$emit("getFBEmail");
          } else {
            // show error
            let ErrorData = {
              Code: response.error,
              Message: response.reason ? response.reason : response
            };
            console.log('error data', ErrorData);
            EventBus.$emit("loginError", ErrorData);
            // Them return out of the method
            return;
          }
        } else {
          //
          this.loginData = response;
          // Get the subscriber information. Pass the email which is used to login
          this.getSubscriberData(this.loginData.email);
          //
          // this.initFCMNotifications ();
        }
      })
      .catch(error => {
        // show error
        let ErrorData = {
          Code: error.status,
          Message: error.bodyText ? error.bodyText : error
        };
        EventBus.$emit("loginError", ErrorData);
      });
  }
  getSubscriberData(email) {
    let data = { email };
    // Make the get subscriber API call to get subscriber data. Defined in User Store.
    store
      .dispatch("actGetSubscriber", data)
      .then(response => {
        let AppUser = JSON.stringify({ ...this.loginData, ...response });
        // Save user data in the name of AppUser to local storage
        localStorage.setItem("AppUser", AppUser);
        // Commit User Store
        store.commit("CommitUserStore");
        //
        EventBus.$emit("loginSuccess");
        //
        this.initFCMNotifications();
        // window.location.reload()
      })
      .catch(error => {
        let ErrorData = {
          Code: error.status,
          Message: error.bodyText ? error.bodyText : error
        };
        EventBus.$emit("loginError", ErrorData);
      });
  }
  initFCMNotifications() {
    // Retrieve Firebase Messaging object.
    let secondary = firebase.app("secondary");
    const messaging = secondary.messaging();
    // Add the public key generated from the console here.
    messaging.usePublicVapidKey(store.getters.FCM_CERTIFICATE_KEY2);

    if (navigator.serviceWorker) {
      navigator.serviceWorker.register("static/sw.js").then(
        registration => {
          messaging.useServiceWorker(registration);

          messaging
            .requestPermission()
            .then(res => {
              messaging
                .getToken()
                .then(token => {
                  console.log('token', token);
                  // let url = `${store.getters.FCM_BASE_URL2}/${token}/rel/topics/${store.getters.FCM_TOPIC_NAME_PREFIX}${store.getters.vendorid}`;

                  // console.log("[firebase url]", url);

                  // fetch(url, {
                  //   method: "POST",
                  //   headers: new Headers({
                  //     Authorization: `key=${store.getters.FCM_SERVER_KEY2}`
                  //   })
                  // })
                  //   .then(() => {
                  //     console.log("[Vendor Topics Subscribed]");
                  //   })
                  //   .catch(error => {
                  //     console.log("[error]", error);
                  //   });
                  // const listenToSubscriberNotification = () => {
                  //   let subscriberUrl = `${store.getters.FCM_BASE_URL2}/${token}/rel/topics/${store.getters.FCM_TOPIC_NAME_PREFIX}${store.getters.vendorid}_${store.getters.subscriberid}`;

                  //   console.log("[subscriberUrl]", subscriberUrl);

                  //   fetch(subscriberUrl, {
                  //     method: "POST",
                  //     headers: new Headers({
                  //       Authorization: `key=${store.getters.FCM_SERVER_KEY2}`
                  //     })
                  //   })
                  //     .then(response => {
                  //       console.log("[Subscriber Topics Subscribed]");
                  //     })
                  //     .catch(error => {});
                  // };
                  // if (store.getters.subscriberid) {
                  //   listenToSubscriberNotification();
                  // }
                  localStorage.setItem("messageToken", token);
                  // notification
                  let notificationStatus = localStorage.getItem(
                    "notificationStatus"
                  );
                  // console.log("notificationStatus", notificationStatus);
                  if (
                    notificationStatus !== null &&
                    JSON.parse(notificationStatus)
                  ) {
                    store.dispatch("subscribeVendorAndSubscriberTopics");
                  } else {
                    if (notificationStatus === null) {
                      localStorage.setItem(
                        "notificationStatus",
                        JSON.stringify(true)
                      );
                      store.dispatch("subscribeVendorAndSubscriberTopics");
                    }
                  }
                })
                .catch(err => {
                  console.log("[err]", err);
                });
            })
            .catch(err => {
              console.log("[err]", err);
            });
          // firebase.notifications().onNotification(notification => {
          //   console("Inside notification", notification);
          // });
          messaging.onMessage(function(payload) {
            // console.log("[onMessage payload]", payload);
            //if (!store.getters.AppUser) return;

            let data = {
              ...payload,
              read: false,
              timestamp: new Date()
              // timestamp: Math.floor(new Date().getTime() / 1000)
            };
            let fcm_notifications = localStorage.getItem("fcm_notifications");
            let notifications;
            if (fcm_notifications) {
              notifications = JSON.parse(fcm_notifications);
              notifications = [...notifications, data];
            } else {
              notifications = [data];
            }
            notifications = notifications.slice().reverse();

            localStorage.setItem(
              "fcm_notifications",
              JSON.stringify(notifications)
            );
            store.commit("commitFCMNotifications", true);

            if (Notification.permission === "granted") {
              let data = payload.data;
              var title = "SDG Notification";
              let body = "New message from SDG";
              let image = null;
              if (payload.data) {
                title = data.title;
                body = data.message;
                image = data.image_url;
              }
              var options = {
                body,
                image
              };
              registration.showNotification(title, options);
            }
          });
        },
        error => {
          console.log("sw not reg", error);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/user-class.js